import { render } from "./RadioGroup.vue?vue&type=template&id=76eb2eaf"
import script from "./RadioGroup.vue?vue&type=script&lang=js"
export * from "./RadioGroup.vue?vue&type=script&lang=js"
script.render = render

export default script